/**
 * Various functions to handle firebase storage files
 */
export class StorageHlp {
  public static readonly ID_LENGTH = 21;

  /**
   * Get storage path from file's download URL
   * @param {string | null | undefined} url file download URL
   * @return {string | undefined} storage path
   */
  public static urlToPath(url: string | null | undefined): string {
    if (url) {
      const badPath = url.split('/').pop()?.split('?')[0];
      const path = badPath?.split('%2F').join('/').replace(/%20/g, ' ');
      return decodeURIComponent(path ?? '');
    }
    return '';
  }

  /**
   * Get file name from storage path
   * @param {string}  path storage filepath (eg. static/documents/id/filename)
   * @return {string} file name
   */
  public static pathToName(path: string | null | undefined): string {
    // workaround: file names in storage are id-uploadedFileName
    // id has 20 chars, older approach uses split('-'), but "-" is also legal char inside id
    // also, replaces spacebars in names
    return path?.split('/').pop()?.substring(StorageHlp.ID_LENGTH).replace(/%20/g, ' ') ?? '';
  }

  /**
   * Get file name from download URL
   * @param {string} url file download URL
   * @return {string} file name
   */
  public static urlToName(url: string | null | undefined): string {
    return StorageHlp.pathToName(StorageHlp.urlToPath(url));
  }
}
